module.exports = __webpack_public_path__ + "static/media/anna_sotneva.a02ece73.jpg";